// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__c3Enr","rootNoMargin":"styles_rootNoMargin__1VWrY"};